import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { i18n } from '../../language';
import { verFunc } from '../../utils/version';
import DiaLog from '../../components/Dialog';
import { closeRefreshDialog } from '../../redux/actions';

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.6rem',
    color: '#2e4469',
  },
}));

const VersionChecker = ({ checkVersionIntervalSecond = 1800 }) => {
  const classes = useStyles();
  const versionState = useSelector((state) => state.versionReducer);
  const dispatch = useDispatch();

  const checkCurrentVersion = async () => {
    await verFunc.getVersion();
  };

  const refreshPage = () => {
    window.location.reload();
  };

  useEffect(() => {
    let activeTimer;
    const setActiveTimer = () => {
      clearInterval(activeTimer);
      activeTimer = setInterval(() => {
        checkCurrentVersion();
      }, checkVersionIntervalSecond * 1000);
    };

    setActiveTimer();
    checkCurrentVersion();

    return () => {
      clearInterval(activeTimer);
    };
  }, [checkVersionIntervalSecond, versionState.version]);

  return (
    <DiaLog
      open={versionState.open}
      confirm={i18n.t('SYS_VERSION_CHECK_REFRESH')}
      cancel={i18n.t('EHANDOVER_NOTE_DELETE_CANCEL')}
      handleCancel={() => {
        dispatch(closeRefreshDialog());
      }}
      handleClose={() => {
        dispatch(closeRefreshDialog());
      }}
      handleConfirm={refreshPage}
      haveHead={false}
    >
      <div className={classes.dialogContent}>{i18n.t('SYS_VERSION_CHECK_DESC')}</div>
    </DiaLog>
  );
};

export default VersionChecker;
